import axios from "axios";
import VueCookies from "vue-cookies";
import store from "@/store";
import { tip, toLogin } from "./utils";

const errorHandle = (status, msg) => {
  switch (status) {
    // 400: 程式邏輯錯誤
    case 400:
      store.dispatch("updateLoading", false);
      tip(msg.errors);
      break;

    // 401: token 過期
    case 401:
      store.dispatch("updateLoading", false);
      toLogin();
      break;

    // 403: 登入驗證失敗
    case 403:
      store.dispatch("updateLoading", false);
      tip("帳號/密碼錯誤，登入失敗。");
      break;

    // 404: 找不到網頁
    case 404:
      store.dispatch("updateLoading", false);
      tip("A 404 ERROR<br/>請聯繫系統管理員。");
      break;

    // 405: Method Not Allowed
    case 405:
      store.dispatch("updateLoading", false);
      tip("Request failed with status code 405<br/>請聯繫系統管理員。");
      break;

    // 500: Server Error
    case 500:
      store.dispatch("updateLoading", false);
      tip("Internal Server Error 500<br/>請聯繫系統管理員。");
      break;

    default:
      store.dispatch("updateLoading", false);
      console.error("沒有攔截到的錯誤:" + msg);
  }
};

//  axios 實例
const instance = axios.create({
  baseURL: `${window.endpoints.api}`,
  timeout: 300000,
});

//  request 攔截器
instance.interceptors.request.use(
  (config) => {
    let headers = {
      Authorization: "Bearer " + VueCookies.get("AUTH_TOKEN"),
      "Content-Type": "application/json; charset=utf-8",
    };
    config.headers = { ...headers, ...config.headers };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

//  response 攔截器
instance.interceptors.response.use(
  (config) => {
    if (config.headers.authorization) {
      VueCookies.set("AUTH_TOKEN", config.headers.authorization);
    }
    return config;
  },
  (error) => {
    const { response } = error;
    if (response) {
      // 成功發出請求且收到 response，但有 error
      errorHandle(response.status, response.data);
      return Promise.reject(error);
    }
    // 成功發出請求但沒收到 response
    if (!window.navigator.onLine) {
      // 如果網路斷線
      tip("網路出了點問題，請重新連線後刷新網頁。");
    } else {
      // 可能是跨域或是程式問題
      tip("系統程式發生錯誤，請聯繫系統管理員。");
    }

    // 無論是哪種情況，最後都 reject 錯誤
    return Promise.reject(error);
  }
);

function prepareDataForBody(data) {
  // 如果 data 是 null 或 undefined，回傳空物件，否則回傳原值
  return data ?? {};
}

export default function (method, url, data = null, config = {}) {
  method = method.toLowerCase();

  switch (method) {
    case "get":
      return instance.get(url, { params: data, ...config });
    case "post":
      return instance.post(url, prepareDataForBody(data), { ...config });
    case "put":
      return instance.put(url, prepareDataForBody(data));
    case "delete":
      return instance.delete(url, { data: data });
    default: {
      const errorMessage = `未知的 method: ${method}`;
      console.error(errorMessage);
      return Promise.reject(new Error(errorMessage));
    }
  }
}
